import { render, staticRenderFns } from "./UpdateVersionPopup.vue?vue&type=template&id=e75a944c&scoped=true&"
import script from "./UpdateVersionPopup.vue?vue&type=script&lang=js&"
export * from "./UpdateVersionPopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVersionPopup.vue?vue&type=style&index=0&id=e75a944c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75a944c",
  null
  
)

export default component.exports